// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 61104, offsets 557713:557834. Structure and names inferred from code, not screenshots.

const __bundleModule = {
  exports: {},
};
const __bundleExports = __bundleModule.exports;
__bundleModule.exports = JSON.parse(
  '["quick-start/terms/privacy-policy","quick-start/terms/user-agreement"]',
);
export default __bundleModule.exports;
